import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Firebase
import { firebaseApp } from './firebase'
import { getAnalytics } from 'firebase/analytics'
if (typeof window !== 'undefined' && window.location?.hostname != 'localhost') {
    //@ts-ignore
    window['_ga'] = getAnalytics(firebaseApp);
}

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
// Import Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


import Vue3TouchEvents, { type Vue3TouchEventsOptions } from "vue3-touch-events";


/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faFileLines } from '@fortawesome/free-regular-svg-icons'
import {  } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
/* add icons to the library */
library.add(faGithub, faLinkedin, faFileLines)

createApp(App)
    .use(router)
    .use<Vue3TouchEventsOptions>(Vue3TouchEvents, {})
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
